import React, { useEffect } from 'react';
import useAutoJoinSocialPlusCommunity from '../SocialPlusForum/useAutoJoinSocialPlusCommunity';
import { AmityCommunityProfilePage, AmityPostDetailPage, useAmityNavigation } from '@frn/amityco-ui-kit-open-source';
// eslint-disable-next-line import/no-webpack-loader-syntax
import socialPlusStyles from '!!css-loader?{"sourceMap":false,"exportType":"string"}!@frn/amityco-ui-kit-open-source/dist/index.css';
import overrideStyles from '!!css-loader?{"sourceMap":false,"exportType":"string"}!./overrides.css';

const SocialPlusSingleCommunityForum = ({ communityId }) => {
  const {
    page: { type, context },
    onClickCommunity
  } = useAmityNavigation();

  useEffect(() => {
    onClickCommunity(communityId);
  }, [communityId]);

  useAutoJoinSocialPlusCommunity(communityId);

  return (
    <div style={{ maxWidth: '600px', margin: '0 auto' }}>
      <style type="text/css" scoped>
        {socialPlusStyles}
      </style>
      <style>{overrideStyles}</style>
      {type === 'PostDetailPage' ? (
        <AmityPostDetailPage {...context} id={context.postId} />
      ) : (
        <AmityCommunityProfilePage {...context} communityId={communityId} />
      )}
    </div>
  );
};

export default SocialPlusSingleCommunityForum;
